import React from 'react';
import { TextField } from '@plug/ui';
import { useTranslation } from 'react-i18next';

const IntegrationFormTray = () => {
  const { t } = useTranslation();

  return (
    <>
      <TextField
        label={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.tray.alias.label',
        )}
        name="trayAlias"
        placeholder={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.tray.alias.placeholder',
        )}
        width="100%"
      />
      <TextField
        label={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.tray.userStoreCode.label',
        )}
        name="trayStoreCode"
        placeholder={t(
          'hubly-dashboard.settings.admin.accordion.items.integration.body.form.tray.userStoreCode.placeholder',
        )}
        width="100%"
      />
    </>
  );
};

export default IntegrationFormTray;
